import { render, staticRenderFns } from "./ShareVideos.vue?vue&type=template&id=6207b0ae&"
import script from "./ShareVideos.vue?vue&type=script&lang=js&"
export * from "./ShareVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports